import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  AnnouncementsWidgetBaseComponent,
  getAnnouncements,
  IAnnouncementsState,
  ImmomioIconName,
  LoadingType,
} from '@resident-nx/shared';
import { ROUTE } from '../../../models';
import { ContentCardPreset } from '../../molecules/content-card/content-card.model';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { ContentCardWebComponent } from '../../molecules/content-card/content-card.component';
import { CardsContainerHeaderWebComponent } from '../../molecules/cards-container-header/cards-container-header.component';
import { LoadingSkeletonWebComponent } from '../../atoms/loading-skeleton/loading-skeleton.component';

@Component({
  standalone: true,
  selector: 'rs-web-announcements-widget',
  templateUrl: './announcements-widget.component.html',
  styleUrls: ['./announcements-widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoadingSkeletonWebComponent,
    CardsContainerHeaderWebComponent,
    ContentCardWebComponent,
    AsyncPipe,
    TranslateModule,
    RouterLink,
  ],
})
export class AnnouncementsWidgetWebComponent extends AnnouncementsWidgetBaseComponent {
  @Input() override icon = ImmomioIconName.News;
  @Input() override title = 'news.announcements_l';
  @Input() override buttonText = 'news.more_announcements_a';
  @Input() showAmountOfContent = false;
  public announcementsLimit = 4;
  public override announcements$ = this.announcementsStore.select(getAnnouncements);
  protected readonly LoadingType = LoadingType;
  public preset = ContentCardPreset;
  public overviewLink = ['/', ROUTE.NEWS, ROUTE.ANNOUNCEMENTS];

  constructor(protected override announcementsStore: Store<IAnnouncementsState>) {
    super(announcementsStore);
  }

  public onTap(announcementId: string): void {
    this.tapped.emit(announcementId);
  }

  public onTapOverview(): void {
    this.overviewTapped.emit();
  }
}
